import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIconButton } from '@angular/material/button';
import type { AuditLogDetailsDialogData } from '../model/audit-log-details-dialog-data';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatFooterCell,
  MatFooterCellDef,
  MatFooterRow,
  MatFooterRowDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import type { AuditLogEntityChange } from '../model/audit-log-entity-change';
import { IsValidIsoStringPipe } from '../../../shared/pipes/is-valid-iso-string.pipe';
import { ServerDateTimePipe } from '../../../shared/pipes/server-date-time.pipe';
import { MatIcon } from '@angular/material/icon';
import { IsNilPipe } from '../../../shared/pipes/is-nil.pipe';
import { IsEmptyPipe } from '../../../shared/pipes/is-empty.pipe';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-audit-log-details-dialog',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    TranslocoDirective,
    MatDialogClose,
    MatTable,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatFooterCell,
    MatFooterRow,
    MatFooterRowDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatFooterCellDef,
    IsValidIsoStringPipe,
    ServerDateTimePipe,
    MatIcon,
    MatIconButton,
    IsNilPipe,
    IsEmptyPipe,
    NgTemplateOutlet,
  ],
  templateUrl: './audit-log-details-dialog.component.html',
  styleUrl: './audit-log-details-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditLogDetailsDialogComponent {
  protected readonly data = inject<AuditLogDetailsDialogData>(MAT_DIALOG_DATA);

  protected readonly dataSource = new MatTableDataSource<AuditLogEntityChange>(this.data.changes);
  protected readonly displayedColumns = ['fieldName', 'oldValue', 'newValue'];
}
